import React, {useEffect, useState} from 'react'
import {Box, Spinner} from 'grommet'
import {useParams} from "react-router-dom";
import {Typography} from "antd";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {BridgeOperation, BridgeOperationActionType, BridgeOperationStatus, getOperation} from "../../api/bridge";
import {useBridge} from "../../providers/BridgeDataProvider";
import {approveEthManager, lockTokenCall} from "./utils";
import {BridgeAction} from "./BridgeAction";
import {capitalizeFirstLetter} from "../../utils";
import usePoller from "../../hooks/usePoller";
import {useAccount, useNetwork} from "wagmi";
import {switchNetwork} from "@wagmi/core";
import {networks} from "./networks";

const StatusColor = {
  [BridgeOperationStatus.waiting]: 'unset',
  [BridgeOperationStatus.inProgress]: 'unset',
  [BridgeOperationStatus.success]: '#70D693',
  [BridgeOperationStatus.canceled]: '#F06666',
  [BridgeOperationStatus.error]: '#F06666',

}
const OperationStatus = (props: { operation?: BridgeOperation }) => {
  const { operation } = props

  // if(operation) {
  //   operation.status = BridgeOperationStatus.inProgress
  // }

  let background = operation ? StatusColor[operation.status] : 'unset'
  return <Box align={'center'}>
    <Box width={'46px'} height={'46px'} background={background} round={'46px'} align={'center'} justify={'center'}>
      {operation?.status === BridgeOperationStatus.success &&
          <CheckOutlined style={{ fontSize: '26px', color: 'white' }} />
      }
      {operation && [BridgeOperationStatus.canceled, BridgeOperationStatus.error].includes(operation.status) &&
          <CloseOutlined style={{ fontSize: '26px', color: 'white' }} />
      }
      {operation?.status === BridgeOperationStatus.inProgress &&
        <Spinner />
      }
    </Box>
    <Typography.Text style={{ fontSize: '18px' }}>
      {capitalizeFirstLetter(operation?.status || 'Waiting...')}
    </Typography.Text>
  </Box>
}

export const OperationTrack = () => {
  const routeParams = useParams()
  const operationId = routeParams.operationId
  const { chain } = useNetwork()

  const { tokens } = useBridge()
  const { isConnected, connector } = useAccount()

  const [isExecuting, setExecuting] = useState<boolean>(false)
  const [operation, setOperation] = useState<BridgeOperation>()

  const executeSteps = async (operation: BridgeOperation) => {
    const getActionByType = (type: BridgeOperationActionType) => {
      return (operation?.actions || []).find((action) => action.type === type)
    }
    console.log('executeSteps:', operation)

    const operationNetwork = networks[operation?.network]
    if(operationNetwork && operationNetwork.id !== chain?.id) {
      await switchNetwork({ chainId: operationNetwork.id }).catch(e => { console.error('Failed to switch network', e) })
    }

    const approveEthManger = getActionByType(BridgeOperationActionType.approveEthManger)

    if(approveEthManger) {
      if(approveEthManger.status === BridgeOperationStatus.waiting) {
        console.log('Start approveEthManger operation...', approveEthManger)
        const data = await approveEthManager({
          operation,
          tokens
        })
        console.log('approveEthManager result:', data)
        setOperation(data)
      } else if(approveEthManger.status === 'error') {
        return
      }
    }

    const lockToken = getActionByType(BridgeOperationActionType.lockToken)
    if(lockToken && lockToken.status === BridgeOperationStatus.waiting) {
      const data = await lockTokenCall({
        operation,
        tokens
      })
      setOperation(data)
      console.log('lockToken result', data)
    }
  }

  useEffect(() => {
    if(isConnected && operation && tokens.length > 0 && !isExecuting && connector?.ready) {
      setExecuting(true)
      executeSteps(operation).catch(e => {
        console.error('executeSteps failed:', e)
      })
    }
  }, [tokens, operation, isExecuting, isConnected, connector]);

  const loadOperationData = async () => {
    try {
      if(operationId) {
        const data = await getOperation(operationId)
        setOperation(data)
      }
    } catch (e) {
      console.error('Failed to load operation', e)
    }
  }

  useEffect(() => {
    loadOperationData()
  }, [operationId]);

  usePoller(() => {
    loadOperationData()
  }, 5000)

  return <Box>
    <Box>
      <Box justify={'center'} align={'center'}>
        <OperationStatus operation={operation} />
      </Box>
      <Box margin={{ top: '8px' }} align={'center'}>
        <Typography.Text copyable={{ text: operationId }} style={{ fontSize: '18px' }}>
          Operation ID: {operationId}
        </Typography.Text>
      </Box>
    </Box>
    {operation &&
        <Box margin={{ top: '8px' }}>
          {(operation.actions).map((action, index) => <BridgeAction
            key={action.id}
            index={index + 1}
            action={action}
            operation={operation}
          />)}
        </Box>
    }
  </Box>
}
